import * as React from 'react';

import { observer } from 'mobx-react';

import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { useTranslation } from '~utils/hooks/translations';

import { CenterMessageView } from './CenterMessageView';

interface IUserSessionSuspenseProps {
    children: React.ReactElement;
}

export const UserSessionSuspense = observer(function _UserSessionSuspense({
    children
}: IUserSessionSuspenseProps) {
    const [hasError, setHasError] = React.useState(false);
    const { genericError, loadingLabel } = useTranslation();

    const viewController = React.useMemo(
        () => diContainer.get(serviceNames.userSessionSuspenseViewController),
        []
    );

    const {
        data: { sessionResponse }
    } = viewController;

    React.useEffect(() => {
        (viewController.loaded() as Promise<void>).catch(setHasError);
    }, []);

    if (hasError) {
        return <CenterMessageView>{genericError}</CenterMessageView>;
    }

    return sessionResponse ? children : <CenterMessageView>{loadingLabel}</CenterMessageView>;
});
